import usuario from "@/locales/languages/es_MX/view/seguridad/usuario";
import perfil from "@/locales/languages/es_MX/view/seguridad/perfil";
import usuariosPerfiles from "@/locales/languages/es_MX/view/seguridad/usuarioPerfiles";
import privilegiosPerfiles from "@/locales/languages/es_MX/view/seguridad/privilegiosPerfiles";
import perfilUsuario from "@/locales/languages/es_MX/view/seguridad/perfilUsuario";

export default {
  usuario
  , perfil
  , usuariosPerfiles
  , privilegiosPerfiles
  , perfilUsuario
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/seguridad/index.js